const DEFAULT_PAGE = 1;
const DEFAULT_LIMIT = 10;
const DEFAULT_OFFSET = 0;
export class LeadsService {
    constructor(context) {
      this.context = context;
      this.axios = this.context.$axios;
    }


    async GetLeads({
      subscriberId,
      businessUnitId,
      startDate,
      endDate,
      status,
      page=DEFAULT_PAGE,
      limit=DEFAULT_LIMIT,
      offset=DEFAULT_OFFSET,
    }) {
      try {
        const leadsBySubscriber = await this.axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/leads?startDate=${startDate}&endDate=${endDate}&subscriberId=${subscriberId}&businessunitId=${businessUnitId}&status=${status}&page=${page}&limit=${limit}&offset=${offset}`
        );
        return leadsBySubscriber.data;
      } catch (err) {
        console.log(err);
      }
    }

    async GetLeadsToExport({
      subscriberId,
      businessUnitId,
      startDate,
      endDate,
      status,
    }) {
      try {
        const leadsBySubscriber = await this.axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/leads/export?startDate=${startDate}&endDate=${endDate}&subscriberId=${subscriberId}&businessunitId=${businessUnitId}&status=${status}`
        );
        return leadsBySubscriber.data;
      } catch (err) {
        console.log(err);
      }
    }
    async UpdateLeadsStatus({ leadId, status }) {
      try {
        const update = await this.axios.patch(
          `${process.env.VUE_APP_API_BASE_URL}/leads/${leadId}/status?status=${status}`
        );

        return update.status;
      } catch (err) {
        console.log(`Fallo la peticion:${err}`);
        return err.toString();
      }
    }
  
}